module.exports = __webpack_public_path__ + "img/pageBg1.c3865d7e.png";